export type StockTypeLabel = "Owned" | "Reserved" | "SHI Stock";

const ETA_DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: "UTC",
});

export function mapRowTypeToLabel(rowType?: number | string | null): StockTypeLabel | null {
  if (rowType === null || rowType === undefined) return null;

  if (typeof rowType === "number") {
    if (rowType === 0) return "SHI Stock";
    if (rowType === 1) return "Owned";
    if (rowType === 2) return "Reserved";
    return null;
  }

  const normalized = rowType.replace(/[^a-z]/gi, "").toLowerCase();
  if (normalized === "owned" || normalized === "ownedstock") return "Owned";
  if (normalized === "reserved" || normalized === "reservedstock") return "Reserved";
  if (normalized === "shistock") return "SHI Stock";

  return null;
}

export function formatEtaDate(value?: Date | string | null): string {
  if (!value) return "";

  const parsed = value instanceof Date ? value : new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return ETA_DATE_FORMATTER.format(parsed);
  }

  if (typeof value !== "string") {
    return "";
  }

  const rawDateMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
  return rawDateMatch ? rawDateMatch[1] : value;
}
